module.exports = __webpack_public_path__ + "assets/img/FT.7f658822.png";